import { cn } from '@/lib/utils'

export type MarketingStepItem = {
  number: string
  title: string
  description: string
}

type MarketingStepsRowProps = {
  steps: MarketingStepItem[]
  className?: string
}

export function MarketingStepsRow({ steps, className }: MarketingStepsRowProps) {
  return (
    <ol className={cn('mt-[34px] grid list-none grid-cols-1 gap-[18px] p-0 sm:grid-cols-3', className)}>
      {steps.map((step) => (
        <li
          key={step.number}
          className="border-t border-[var(--marketing-border,#e9e3d6)] px-0 py-6 sm:px-6 sm:py-6"
        >
          <div className="mb-3 font-extrabold text-[var(--marketing-eyebrow,#9b780d)]">{step.number}</div>
          <strong className="block text-[var(--marketing-text,#1f2528)]">{step.title}</strong>
          <span className="mt-1 block text-base leading-relaxed text-[var(--marketing-muted,#667078)]">
            {step.description}
          </span>
        </li>
      ))}
    </ol>
  )
}
